import React from 'react';
import styled from 'styled-components';

import { useDiscountedItem } from 'modules/campaigns/hooks/useDiscountedItem';

import { Estimations, EstimationsProps } from '../Estimations';
import ProductCard from '../ProductCard/ProductCard';
import VenueCard, { VenueCardProps } from '../VenueCard';

export type ItemDiscountPreviewProps = EstimationsProps & {
  itemIds: string[];
  categoryIds: string[];
  menuId: string;
} & Partial<VenueCardProps>;

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-block-start: 12px;
`;

const BannerContainer = styled.div`
  margin: 0 16px;
`;

export const ItemDiscountPreview = ({
  itemIds,
  categoryIds,
  menuId,
  banner,
  venueDetails,
  ...estimationsProps
}: ItemDiscountPreviewProps) => {
  // Use the item in preview only if there is exactly one item
  const singleItemOnly = itemIds.length <= 1 && !categoryIds.length;
  const itemId = singleItemOnly ? itemIds[0] : undefined;
  const { discountedItem } = useDiscountedItem({ itemId, menuId });

  if (!singleItemOnly) {
    return (
      <StyledRoot>
        {venueDetails ? (
          <VenueCard venueDetails={venueDetails} banner={banner} />
        ) : (
          !!banner && <BannerContainer>{banner}</BannerContainer>
        )}
        <Estimations {...estimationsProps} />
      </StyledRoot>
    );
  }

  return (
    <StyledRoot>
      <ProductCard product={discountedItem} banner={banner} />
      <Estimations {...estimationsProps} />
    </StyledRoot>
  );
};
